// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TableData_border__E6iFj {\n  border-top: 1px solid var(--border-table);\n}\n.TableData_container__3Hr1v {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Includes/Table/TableData.module.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;AAC3C;AACA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B","sourcesContent":[".border {\n  border-top: 1px solid var(--border-table);\n}\n.container {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"border": "TableData_border__E6iFj",
	"container": "TableData_container__3Hr1v"
};
export default ___CSS_LOADER_EXPORT___;
